import React from 'react';
import PropTypes from 'prop-types';
import { WidgetSliderMobile } from '../css';
import Slide from './Slide';

const SliderMobile = (props) => {
  const { news } = props;

  return (
    <WidgetSliderMobile>
      {news.map((item, index) => (<Slide key={`slide-${index}`} {...item} />
      ))}
    </WidgetSliderMobile>
  );
};

SliderMobile.propTypes = {
  news: PropTypes.array,
};

export default SliderMobile;
